
import {Helmet} from "react-helmet";
import LoginComponent from "../components/LoginComponent";
import { useSearchParams } from "react-router-dom";
import { Carousel } from "react-bootstrap";
const Login = ({pageTitle}) => {
    const [searchParams] = useSearchParams();
    const source = searchParams.get("source");



    const slides = [
        {
        video: "https://d3orgd3vfbg4nb.cloudfront.net/landingpage_videos/example1.mp4"
        },
        {
        video: "https://d3orgd3vfbg4nb.cloudfront.net/landingpage_videos/example2.mp4"
        },
        {
        video: "https://d3orgd3vfbg4nb.cloudfront.net/landingpage_videos/example3.mp4"
        },
        {
        video: "https://d3orgd3vfbg4nb.cloudfront.net/landingpage_videos/example4.mp4"
        },
        {
        video: "https://d3orgd3vfbg4nb.cloudfront.net/landingpage_videos/example5.mp4"
        }
    ];

    return (
        <>
            <Helmet >
                <title>{pageTitle}</title>
            </Helmet>
            <div className='pxl_loginWrapper'>
                <div className='pxl_mainContainer'>
                    <div className='pxl_login_left_sec' style={{ backgroundImage: `url(${
                        source ? `./assets/images/login/${source}_bg.png` : `./assets/images/login/pixalab_bg.png`
                    })` }}>

                        {
                            source == 'showcaseai' ?
                            <div className="pxl_sa_left_main_wrap">
                                <div className="pxl_sa_left_logo">
                                    <img src="./assets/images/login/showcaseai_normal_logo.png" alt="image" />
                                </div>
                                <Carousel interval={3000} fade controls indicators className="pxl_sa_slider_wrap">
                                    {slides.map((item, index) => (
                                        <Carousel.Item key={index}>
                                            <div className="pxl_sa_video_wrap">
                                                <video
                                                    muted
                                                    loop
                                                    autoPlay
                                                    playsInline
                                                    className="lazy-video"
                                                    preload="none"
                                                >
                                                    <source src={item.video} type="video/mp4" />
                                                </video>
                                            </div>
                                        </Carousel.Item>
                                    ))}
                                </Carousel>
                                <h2 className="pxl_sa_btm_heading">Transform Ideas into <br/> Stunning Video Content</h2>
                            </div>
                            :
                            <div className="pxl_main_left_main_wrap">
                                <div className="pxl_main_left_main_img">
                                    <img src="./assets/images/login/pixalab_img_main.png" alt="image" />
                                    <div className="pxl_main_left_ia_list">
                                        <div className="pxl_main_left_iai_icon pos-scheduler" title="Pixa Scheduler">
                                            <img className="logo" src="./assets/images/login/vector/pixascheduler.png" alt="Pixa Scheduler logo"/>
                                        </div>

                                        <div className="pxl_main_left_iai_icon pos-pages" title="Pixel Pages">
                                            <img className="logo" src="./assets/images/login/vector/pp.png" alt="Pixel Pages logo"/>

                                        </div>

                                        <div className="pxl_main_left_iai_icon pos-booking" title="PixaBooking">
                                            <img className="logo" src="./assets/images/login/vector/pb.png" alt="PixaBooking logo"/>

                                        </div>

                                        <div className="pxl_main_left_iai_icon pos-template" title="Template Bundle">
                                            <img className="logo" src="./assets/images/login/vector/tb.png" alt="Template Bundle logo"/>

                                        </div>

                                        <div className="pxl_main_left_iai_icon pos-showcase" title="Showcase AI">
                                            <img className="logo" src="./assets/images/login/vector/sa.png" alt="Showcase AI logo"/>

                                        </div>

                                        <div className="pxl_main_left_iai_icon pos-url" title="PixaURL">
                                            <img className="logo" src="./assets/images/login/vector/pu.png" alt="PixaURL logo"/>

                                        </div>

                                        <div className="pxl_main_left_iai_icon pos-support" title="PixaSupport">
                                            <img className="logo" src="./assets/images/login/vector/pixasupport.png" alt="PixaSupport logo"/>

                                        </div>
                                    </div>
                                </div>
                                <h2 className="pxl_pixalab_btm_heading">Run your entire business from one platform</h2>
                            </div>


                        }



                    </div>


                    <div className='pxl_loginForm order-md-2 order-1'>
                         <LoginComponent />
                    </div>

                </div>
            </div>
        </>
    )
};

export default Login;